<template>
  <div class="flex-col">
    <router-link
      class="rendering-card"
      v-if="!loader"
      :to="{ name: 'result', params: { id: mid } }"
    >
      <figure v-html="image" class="ratio ratio-7/5 bg-gray-200 rounded-md" />
      <div class="overlay" v-if="!loader">
        <p class="text-base c-gray-900">{{ 'View Products in rendering' | t }}</p>
      </div>
    </router-link>
    <figure v-else class="ratio ratio-7/5 bg-gray-200 rounded-md w-100" />
    <footer class="flex items-center justify-between mt-sm">
      <label class="h-100 flex items-center flex-1">
        <input
          v-if="!loader"
          class="m-0"
          type="checkbox"
          :checked="checked"
          @change="onInput"
        />
        <h4 class="text-base fw-regular ml-sm">{{ name }}</h4>
      </label>
      <slo-button
        :href="image_url"
        :download="downloadName"
        fill="outline"
        size="small"
        @click="onDownload($event)"
      >
        <SloIcon name="ArrowDownToLine" />
      </slo-button>
    </footer>
  </div>
</template>

<script>
import t from '../../main/i18n';
import SloButton from '../../../lib/components/SloButton.vue';
import SloIcon from '../../../lib/components/SloIcon.vue';

export default {
  components: {
    SloButton,
    SloIcon
  },
  props: {
    loader: {type: Boolean, default: false},
    checked: {type: Boolean},
    name: {type: String},
    image: {type: String},
    image_url: {type: String},
    width: {type: Number},
    height: {type: Number},
    mid: {type: Number}
  },
  filters: {
    t
  },
  computed: {
    downloadName() {
      if (!this.name) return '';
      const ext = this.image_url.split('.').pop();
      return this.name.toLowerCase().replace(/\s+/g, '-') + '.' + ext;
    }
  },
  methods: {
    onDownload(event) {
      if (navigator.msSaveBlob) {
        event.preventDefault();
        const xhr = new XMLHttpRequest();
        xhr.onloadstart = () => {
          xhr.responseType = 'blob';
        };
        xhr.onload = () => {
          navigator.msSaveOrOpenBlob(xhr.response, this.downloadName);
        };
        xhr.open('GET', this.image_url, true);
        xhr.send();
      }
    },

    onInput() {
      this.$emit('input', this.mid);
    }
  }
};
</script>

<style lang="scss">
@import '../../../scss/system';

.rendering-card {
  position: relative;

  .msie & {
    figure > img {
      max-width: 100%;
      height: auto;
      width: auto;
    }
  }

  figure,
  img {
    will-change: transform;
    transition: 120ms transform ease-in;
  }

  .overlay {
    transition: 120ms transform ease-in, 120ms opacity ease-in;
  }

  ~ footer h4 {
    transition: 120ms color ease-out;
  }

  &:hover,
  &:focus,
  &:focus-within {
    & .overlay {
      opacity: 1;
      transform: translateY(0);
    }

    & figure {
      transform: scale(0.975);
    }

    & img {
      transform: scale(1.05);
    }

    & ~ footer h4 {
      color: $color-blue-400;
    }
  }
}
</style>

<style lang="scss" scoped>
.slo-button {
  width: 32px;
  height: 32px;
  padding: 12px;
}

.overlay {
  position: absolute;
  left: 16px;
  right: 16px;
  bottom: 16px;
  background: white;
  padding: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1;
  pointer-events: none;
  border-radius: 4px;
  opacity: 0;
  transform: translateY(8px);
}
</style>
